module.exports = __webpack_public_path__ + "static/media/detached_blue.6d66202c.svg";